<ion-content>
  <iframe src="https://docs.google.com/presentation/d/1g6RFY1GhruoB8e34StB2KuKHAGfTfQPfmEB_qv8hZJU/edit?usp=sharing" frameborder="0"style="display: block;" width="100%" height="100%" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
</ion-content>
